import { View } from "react-native"
import BFText from "@/components/standard/BFText"
import { TouchableOpacity } from "react-native-gesture-handler"
import CloseButton from "@/assets/icons/white-close-button.svg"

interface NotificationToastProps {
  message: string
  onDismiss: () => void
}

export const NotificationToast = ({
  message,
  onDismiss,
}: NotificationToastProps) => (
  <View className="absolute inset-x-4 bottom-0 flex flex-row h-[40px] items-center bg-midnight-blue rounded-[4px]">
    <View className="flex flex-1">
      <BFText className="font-figtree-bold text-white text-[12px] px-4">
        {message}
      </BFText>
    </View>
    <TouchableOpacity testID={"close-button"} onPress={onDismiss}>
      <CloseButton width={28} height={28} />
    </TouchableOpacity>
  </View>
)
